<template>
  <info-form
    @submit="editEnrollment"
    ref="infoFormRefs"
    :data-detail="dataDetail"
  ></info-form>
</template>
<script>
import InfoForm from "./InfoForm";
import { service_names } from "@/constants/Services";
import pick from "lodash/pick";

export default {
  components: { InfoForm },
  props: ["dataDetail"],
  methods: {
    editEnrollment(item) {
      const studentId = this.$route.params.id;
      const form = pick(item, [
        "grade_id",
        "type",
        "status",
        "calendar",
        "start_date",
        "end_date"
      ]);

      this.$axios
        .put(`${service_names.user}/enrollment/${item._id}`, {
          ...form,
          student_id: studentId
        })
        .then(() => {
          this.$modal.hide("enrollment-detail");
          this.$emit("editingEnrollment");
        });
    }
  }
};
</script>
